export default {
    en: {
        messages: {
            title: "Address Book",
            addEntry: "Add Entry",
            addFirstEntry: "Add Your First Entry",
            loading: "Loading address book...",
            noEntries: "No entries in your address book",
            name: "Name",
            email: "Email",
            cancel: "Cancel",
            update: "Update",
            add: "Add",
            edit: "Edit",
            confirmDeleteTitle: "Confirm Delete",
            confirmDeleteMsg: "Are you sure you want to delete this entry?",
            delete: "Delete",
            entry: "entry",
            entries: "entries",
            total: "total",
            failedToLoad: "Failed to load address book",
            failedToSave: "Failed to save entry",
            failedToDelete: "Failed to delete entry",
            required: "*",
            invalidEmail: "Invalid email address",
            loadingSpinner: "Loading...",
            savingSpinner: "Saving...",
            deletingSpinner: "Deleting...",
        }
    }
}